module.exports = __webpack_public_path__ + "img/program_img2.1c0bd963.png";